const SP = [
    {id: "0", value: "支撐"},    
    {id: "1", value: "壓力"}
  ];  
  
  export default SP  